// Test JavaScript file
console.log('JavaScript loaded successfully!');

document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM Content Loaded!');
    
    // Add test class to body
    document.body.classList.add('js-loaded');
    
    // Test if elements exist
    console.log('Bootstrap classes found:', document.querySelector('.container') !== null);
    console.log('FontAwesome icons found:', document.querySelector('.fas') !== null);
});